module.exports = __webpack_public_path__ + "static/SmartBrain-edbf221bdddc5dcfd528022f5a9fb1e4.png";